module.exports = __webpack_public_path__ + "media/images/countryrect/rw-6a50a648285d43afad1a1b679193e886.svg";